
const orderUtil = {};

orderUtil.patternEditorHeight = 284; //整个pattern编辑器的高度
orderUtil.controlBoxHeight = 246;    //画线区域的canvas + 刻度尺 的高度
orderUtil.canvasHeight = 200;      //画线区域的canvas高度
orderUtil.coMinHeight = 16;   //控制球滑动区域距离底部的最小高度值
orderUtil.coMaxHeight = 156;  //控制球滑动区域距离底部的最大高度值
orderUtil.oneLevelHeight = 7; //控制球滑动区域，每一个level刻度对应的像素高度

orderUtil.controlBoxWidth = 200; //控制球区域宽度

//height的范围：min-max
orderUtil.getLevel = (height, min=orderUtil.coMinHeight, max=orderUtil.coMaxHeight, limit=true) => {
  let level = Math.ceil((height - min)/((max-min)/20));
  if(limit && level > 20){
    level = 20;
  }else if(limit && level < 1){
    level = 0;
  }
  return level;
}

orderUtil.limitLevel = (level) => {
  if(level > 20){
    return 20;
  }else if(level <= 0){
    return 0;
  }
  return level;
}

orderUtil.formatMs = (ms) => {
  return (Math.round(ms/100))*100
}

orderUtil.browserInfo = {
  version: navigatorInfo()
}

orderUtil.isIos = () => {
  let res = navigatorInfo();
  return res.ios;
}
orderUtil.isAndroid = () => {
  let res = navigatorInfo();
  return res.android;
}
orderUtil.isMobile = () => {
  let nv = navigatorInfo();
  if (nv.mobile || nv.ios || nv.android) {
    return true;
  }
  return false;
}

function navigatorInfo() {
  let u = navigator.userAgent;
  // let app = navigator.appVersion;
  return {
    trident: u.indexOf('Trident') > -1, /*IE内核*/
    presto: u.indexOf('Presto') > -1, /*opera内核*/
    webKit: u.indexOf('AppleWebKit') > -1, /*苹果、谷歌内核*/
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, /*火狐内核*/
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), /*是否为移动终端*/
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), /*ios终端*/
    android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, /*android终端或者uc浏览器*/
    iPhone: u.indexOf('iPhone') > -1, /*是否为iPhone或者QQHD浏览器*/
    iPad: u.indexOf('iPad') > -1, /*是否iPad*/
    webApp: u.indexOf('Safari') === -1, /*是否web应该程序，没有头部与底部*/
    souyue: u.indexOf('souyue') > -1,
    superapp: u.indexOf('superapp') > -1,
    weixin: u.toLowerCase().indexOf('micromessenger') > -1,
    Safari: u.indexOf('Safari') > -1
  };
}

// 获取操作系统信息 
orderUtil.getOsInfo = () => {
  let userAgent = navigator.userAgent.toLowerCase();
  let name = '';
  let version = '';
  let browser = "";
  let regs = {};
  if (userAgent.indexOf('win') > -1) {
      name = 'Windows';
      if (userAgent.indexOf('windows nt 5.0') > -1) {
          version = 'Windows 2000';
      } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
          version = 'Windows XP';
      } else if (userAgent.indexOf('windows nt 6.0') > -1) {
          version = 'Windows Vista';
      } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
          version = 'Windows 7';
      } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
          version = 'Windows 8';
      } else if (userAgent.indexOf('windows nt 6.3') > -1) {
          version = 'Windows 8.1';
      } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
          version = 'Windows 10';
      }
  } else if (userAgent.indexOf('iphone') > -1) {
      name = 'Iphone';
  } else if (userAgent.indexOf('mac') > -1) {
      name = 'Mac';
  } else if (userAgent.indexOf('x11') > -1 || userAgent.indexOf('unix') > -1 || userAgent.indexOf('sunname') > -1 || userAgent.indexOf('bsd') > -1) {
      name = 'Unix';
  } else if (userAgent.indexOf('linux') > -1) {
      if (userAgent.indexOf('android') > -1) {
          name = 'Android';
      } else {
          name = 'Linux';
      }
  }
  if (userAgent.match(/msie\s(\d+)\..*/)) {
    regs = userAgent.match(/msie\s(\d+)\..*/);
    // ie 除11
    browser = 'ie ' + regs['1'];
  } else if (userAgent.match(/firefox\/(\d+)\..*/)) {
    regs = userAgent.match(/firefox\/(\d+)\..*/);
    browser = 'firefox ' + regs['1'];
  } else if (userAgent.match(/opera[\s|](\d+)\..*/)) {
    regs = userAgent.match(/opera[\s|](\d+)\..*/);
    browser = 'opera ' + regs['1'];
  } else if (userAgent.match(/chrome\/(\d+)\..*/)) {
    regs = userAgent.match(/chrome\/(\d+)\..*/);
    browser = 'chrome ' + regs['1'];
  } else if (userAgent.match(/safari\/(\d+)\..*$/)) {
    regs = userAgent.match(/safari\/(\d+)\..*$/);
    browser = 'safari ' + regs['1'];
  } else if (userAgent.match(/rv:(\d+)\..*/)) {
    regs = userAgent.match(/rv:(\d+)\..*/);
    // ie 11
    browser = 'ie ' + regs['1'];
  }
  return { name, version, browser };
}

// 深拷贝
orderUtil.deepClone = (parentObj, childObj) => {
  if (!parentObj || typeof parentObj !== 'object') {
    return parentObj; //若果不是对象 直接返回
  }
  childObj = childObj || (Array.isArray(parentObj) ? [] : {})
  try {
    for (let i in parentObj) {
      if (parentObj.hasOwnProperty(i)) {
        childObj[i] =
          typeof parentObj[i] === 'object'
            ? orderUtil.deepClone(parentObj[i], childObj[i])
            : parentObj[i]
      }
    }
  } catch (e) {
    console.error(e)
  }
  return childObj
}

// 根据time获取数据点所在曲线的索引值
orderUtil.getPointIndex = (arr, time) =>{
  let index = -1;
  if(arr.length > 0){
    for(let i=0; i<arr.length; i++){
      let obj = arr[i];
      if(obj.t === time){
        index = i;
        break;
      }
    }
  }
  return index;
}

//获取链接参数信息
orderUtil.getParam = (queryName) =>{
  let query = decodeURI(window.location.search.substring(1));
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] === queryName) { return pair[1]; }
  }
  return null;
}

export default orderUtil;